import DOMUtils from "./dom-utils";
import MessagePoster from "./message-poster";

/**
 * Resizer posts window height changes to the parent window
 * to enable the iframe to be resized and avoid a second level scroll bar.
 */
export default class Resizer {
  #isActive;

  constructor() {
    // The resizer is only active when the page is embedded in an iframe.
    if (window !== window.parent) {
      this.#isActive = true;
    }
  }

  init() {
    if (this.#isActive) {
      // Resize when the body height changes
      DOMUtils.onContentHeightChange($("body"), MessagePoster.postHeight);
    }
  }

  /**
   * Ensures the body has enough height to fit the given element.
   * This is most useful for absolutely positioned elements which
   * are outside of the normal page flow.
   */
  fitElem(elem, padding = 25) {
    if (this.#isActive) {
      const $elem = elem instanceof jQuery ? elem : $(elem);

      // Allow one frame for the element to be drawn
      setTimeout(() => {
        const top = DOMUtils.getElemTop($elem);
        const minBodyHeight = top + $elem.height() + padding;

        const bodyHeight = DOMUtils.getContentHeight($("body"));

        if (bodyHeight < minBodyHeight) {
          MessagePoster.postHeight(minBodyHeight);
        }
      }, 0);
    }
  }
}